import DataReferenceCollection from './DataReferenceCollection.js';
import NormalizedDataReference from './NormalizedDataReference.js';
/**
 * @memberof data-references
 * @classdesc
 * An object that specifies a {DataReferenceCollection} for normalization purposes.
 * The reference could be the same or different from the value being normalized
 * if this object describes which value or how to apply it.
 *
 * @property {?DataReferenceCollection} ref
 */
class DataImplementationNormalization {
    constructor(props = {}) {
        this.ref = null;
        Object.assign(this, props);
        if (this.isPopulated) {
            this.ref = new DataReferenceCollection(this.ref);
        }
    }
    get isPopulated() {
        return this.ref && this.ref.id !== null;
    }
    makeNormalizedDataReferences(numerators) {
        const denominators = this.ref.variables;
        return numerators.map((numerator, index) => {
            const denominator = denominators[index] || last(denominators);
            return denominator ? NormalizedDataReference.from(numerator, denominator) : numerator;
        });
    }
    toJSON() {
        return {
            ref: this.ref.toImplementationJSON(),
        };
    }
}
function last(list) {
    return list[list.length - 1];
}
export default DataImplementationNormalization;
